/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

import JobFeedbackLeftPanel from "./Panels/JobFeedbackLeftPanel";
import JobFeedbackRightPanel from "./Panels/JobFeedbackRightPanel";
import JobReviewFeedbackPopup from "./Popup/JobReviewFeedbackPopup";

import CapitalQuestFeedbackLeftPanel from "./Panels/CapitalQuestFeedbackLeftPanel";
import CapitalQuestFeedbackRightPanel from "./Panels/CapitalQuestFeedbackRightPanel";

const CustomerJobFeedbackBody = () => {
  const params = useParams();

  const [responseData, setResponseData] = useState({});

  const [challengeType, setChallengeType] = useState("talenthunt");


  const [challengeResponseId, setChallengeResponseId] = useState("")



  //** function for get cv details of logged in user */
  const getCvDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GUEST_CHALLENGE_RESPONSE_DETAILS + `/${params.id}`;

      console.log("requestURL in cv details", requestURL);

      const response = await getData(requestURL);

      console.log("response in cv details", response);

      if (response.status) {
        if (response.challengetype) {
          
          setChallengeType(response.challengetype); 
          
          if(response.challengetype === "capitalquest") {
            setResponseData(response.capitalquestdata);
          }else{
            setResponseData(response.data);
          }

        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (params.id) {
      setChallengeResponseId(params.id);

      getCvDetails();
    }
  }, [params.id]);

  return (
    <div class="my_survey_outer cv_wrapper  d-flex">

      {/* if challengeType = capital quest */}

      {challengeType === "capitalquest" ? (
        <CapitalQuestFeedbackLeftPanel 
          cqResponseData={responseData}  
        />
      ) : (
        <JobFeedbackLeftPanel 
        cvResponseData={responseData}  
        />
      )}

      {challengeType === "capitalquest" ? (
        <CapitalQuestFeedbackRightPanel 
        cqResponseData={responseData} 
        />
      ) : (
        <JobFeedbackRightPanel 
        cvResponseData={responseData} 
        />
      )}


      <JobReviewFeedbackPopup 
        challengeResponseId={challengeResponseId}        
      />
    </div>
  );
};

export default CustomerJobFeedbackBody;
